import { Fragment, useContext } from "react";
import { Dialog, Transition } from '@headlessui/react'

import { ModalContext } from '@/contexts/ModalContext'

import ModalMap from '../modals'
// import PublicModal from '../modals/PublicModal'
import { XIcon } from "@heroicons/react/solid";
// import { useAuth } from "../hooks/useAuth";
import ModalTransition from '../transitions/modal.transition'
import Button from "./Button";

export default function Modal() {
  let { closeModal, modal } = useContext(ModalContext);
  // const { user } = useAuth()

  if (!modal) return null

  const currentModal = ModalMap[modal]

  if (!currentModal) return null

  const {
    component,
    icon,
    title,
    hideHeader,
    size = 'default',
    padding = true,
    show2fa = false
  } = currentModal

  const maxWidthClass = {
    default: 'max-w-lg',
    large: 'max-w-lg lg:max-w-3xl',
    xlarge: 'max-w-5xl'
  }[size]

  return (
    <Transition appear show={modal ? true : false} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-[200] overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center flex items-center justify-center">
          <Transition.Child
            as={Fragment}
            {...ModalTransition.Overlay}
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-80" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            {...ModalTransition.Main}
          >
            <div className={`w-full text-sm text-left transition transform bg-gray-800 shadow-2xl rounded-2xl relative text-white text-opacity-70 ${maxWidthClass}`}>
              <div className={`lg:max-h-modal overflow-auto h-full ${padding ? 'p-6 pt-0' : ''}`}>
                {!hideHeader && (
                  <div className="flex items-center bg-gray-800 z-10 justify-between py-4 sticky top-0">
                    <p className="flex items-center"><span className="h-5 w-5 mr-1">{icon}</span><span className="text-white text-sm font-medium">{title}</span></p>
                  </div>)}

                <button onClick={closeModal} className="hover:text-white absolute p-4 right-0 top-0 z-10">
                  <span><XIcon className="h-4 w-4" /></span>
                </button>
                {component}
              </div>
              {/* {show2fa && (
                <div className="p-6 bg-gray-900 text-sm rounded-b-2xl text-center">
                  <p className="text-gray-300 text-xs">Improve your account security with Two-Factor Authentication</p>
                  <div className="flex justify-center">
                    <Button link to="/settings/security" className="mt-3 py-2.5 px-4 text-sm" modifier="secondary">
                      Enable 2FA
                    </Button>
                  </div>
                </div>
              )} */}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
};